;(function () {
  angular
    .module('contrast.bar-chart')
    .directive('csBarChartTooltip', csBarChartTooltip)

  function csBarChartTooltip($compile) {
    'ngInject'

    return {
      restrict: 'A',
      scope: {
        csBarChartTooltipTotal: '@',
        csBarChartTooltipExploited: '@',
        csBarChartTooltipProbed: '@',
        csBarChartTooltipBlocked: '@',
        csBarChartTooltipTime: '@',
        csBarChartTooltipRequests: '@'
      },
      link: function ($scope, element, attrs) {
        if (!element.scope().tooltipLoaded) {
          $scope.total = attrs.csBarChartTooltipTotal
          $scope.exploited = attrs.csBarChartTooltipExploited
          $scope.probed = attrs.csBarChartTooltipProbed
          $scope.blocked = attrs.csBarChartTooltipBlocked
          $scope.time = attrs.csBarChartTooltipTime
          $scope.requests = attrs.csBarChartTooltipRequests

          $scope.tooltipLoaded = true
          element.attr(
            'uib-tooltip-template',
            "'views/tooltips/attacks/attackTrendTooltip.html'"
          )
          element.attr(
            'tooltip-placement',
            attrs.barChartTooltipPlacement || 'auto right'
          )
          element.attr('tooltip-append-to-body', 'true')
          element.attr(
            'tooltip-class',
            'tooltip-robust medium-tooltip tooltip-barchart'
          )
          $compile(element)($scope)
        }
      }
    }
  }
})()
